module.exports = __webpack_public_path__ + "img/6e7cfe12bfbf5d7d0df223b39b4fcd41.png";